import { TrackHTMLAttributes, VideoHTMLAttributes } from "react";

import { Spacer } from "../Spacer";
import { ErrorContainer, VideoElement } from "./styles";

export type VideoProps = Omit<VideoHTMLAttributes<HTMLVideoElement>, "muted" | "src"> & {
  /**
   * Source for the video
   */
  src: string;
  /**
   * If the video is muted
   */
  muted?: boolean;
  /**
   * List of tracks to render as children of the video entity
   */
  tracks?: TrackHTMLAttributes<HTMLTrackElement>[];
};

export const invalidProtocolError = "ERROR: Please make sure you are using https to load this file";
export const invalidFileFormatError = "ERROR: Please make sure you are using the .webm format";
export const errorTestid = "videoError";

export const Video = ({ src, muted = true, tracks = [], ...rest }: VideoProps) => {
  const isInvalidFileFormat = !src.endsWith(".webm");
  const isInvalidProtocol = src.startsWith("http://");

  if (isInvalidFileFormat || isInvalidProtocol) {
    return (
      <ErrorContainer data-testid={errorTestid}>
        {isInvalidFileFormat && invalidFileFormatError}
        <Spacer multiplier={2} />
        {isInvalidProtocol && invalidProtocolError}
      </ErrorContainer>
    );
  }

  return (
    <VideoElement data-testid={Video.name} muted={muted} playsInline={true} src={src} {...rest}>
      {tracks.length
        ? tracks.map((trackProps, index) => <track key={index} {...trackProps} />)
        : null}
    </VideoElement>
  );
};
